import {
  LayoutItem,
  PanelState,
  PanelType,
  isDocumentPanelState,
  isImagePanelState,
  isLogPanelState,
  isMapPanelState,
  isPlotPanelState,
  isRawMessagePanelState,
  isThreeDPanelState,
} from "@/shared/state/visualization";

import { DocumentPanel } from "./DocumentPanel";
import { ImagePanel } from "./ImagePanel";
import { LogPanel } from "./LogPanel";
import { MapPanel } from "./MapPanel";
import { PlotPanel } from "./PlotPanel";
import { PlotPanelProvider } from "./PlotPanel/panelContext";
import { RawMessagePanel } from "./RawMessagePanel";
import { ThreeDPanel } from "./ThreeDPanel";

interface PanelProps {
  layout: LayoutItem;
  panelState: PanelState;
}

export function Panel(props: PanelProps) {
  const { layout, panelState } = props;

  switch (panelState.type) {
    case PanelType.Document: {
      if (!isDocumentPanelState(panelState)) {
        return null;
      }
      return (
        <DocumentPanel key={panelState.id} layout={layout} state={panelState} />
      );
    }
    case PanelType.Log: {
      if (!isLogPanelState(panelState)) {
        return null;
      }
      return (
        <LogPanel key={panelState.id} layout={layout} state={panelState} />
      );
    }
    case PanelType.Image: {
      if (!isImagePanelState(panelState)) {
        return null;
      }
      return (
        <ImagePanel key={panelState.id} layout={layout} state={panelState} />
      );
    }
    case PanelType.Map: {
      if (!isMapPanelState(panelState)) {
        return null;
      }
      return (
        <MapPanel key={panelState.id} layout={layout} state={panelState} />
      );
    }
    case PanelType.Plot: {
      if (!isPlotPanelState(panelState)) {
        return null;
      }
      return (
        <PlotPanelProvider state={panelState}>
          <PlotPanel key={panelState.id} layout={layout} state={panelState} />
        </PlotPanelProvider>
      );
    }
    case PanelType.ThreeD: {
      if (!isThreeDPanelState(panelState)) {
        return null;
      }
      return (
        <ThreeDPanel key={panelState.id} layout={layout} state={panelState} />
      );
    }
    case PanelType.RawMessage: {
      if (!isRawMessagePanelState(panelState)) {
        return null;
      }
      return (
        <RawMessagePanel
          key={panelState.id}
          layout={layout}
          state={panelState}
        />
      );
    }
    default:
      return null;
  }
}
